import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiErrorMessage } from '../utils/errors';
import Icon from './Icon';

// Rendered once inside the logged-in shell (App.tsx). Persistent and
// inline rather than a floating Toast -- this is an ongoing state, not a
// one-off event notification.
const EmailVerificationBanner: React.FC = () => {
  const { email, emailVerified, resendVerification } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (emailVerified !== false || !email) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    setError(null);
    try {
      await resendVerification(email);
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err, 'Could not resend the verification email.'));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="verification-banner">
      <Icon name="warning" className="icon icon-sm" />
      <span>
        {error
          ? error
          : sent
          ? "Verification email sent -- check your inbox."
          : `Please verify ${email} to make sure you can recover your account.`}
      </span>
      {!sent && (
        <button className="verification-banner-action" onClick={handleResend} disabled={sending}>
          {sending ? 'Sending...' : 'Resend email'}
        </button>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
